import { sanitize } from '@luna/utils';
import { useProfileImage } from '@shared/profile';

const WHITE_SPACE_CHAR = ' ';

export function getCleanMessageBody(messageBody = ''): string {
    const inlineImagePattern = /\[cid:.*]/gi;
    const whiteSpacesPattern = /\s+/gi;
    const htmlTagsPattern = /<[^>]*>/gi;

    const cleanedMessage = [inlineImagePattern, htmlTagsPattern, whiteSpacesPattern].reduce(
        (text, currentPattern) => text.replace(currentPattern, WHITE_SPACE_CHAR),
        messageBody,
    );

    return sanitize(cleanedMessage, {
        ALLOWED_TAGS: [],
    }).trim();
}

export const getOwnImage = (): string => {
    const profileImage = useProfileImage.getState().imageBase64;

    if (!profileImage) {
        return '';
    }

    return `data:image/png;base64,${profileImage}`;
};
